import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Datepicker} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Datepicker, {
        'clearable': true,
        'ev-$model:value': function($v) {
            $this.set('date', $v);
        },
        'value': $this.get('date')
    });
};